import { AppTitle } from 'components/atoms/CommonAppComponents';
import styled, { css, useTheme } from 'styled-components';
import { useIsMobile } from 'hooks/useIsMobile/useIsMobile';

type AuthFormTitleProps = {
    titleText: string;
    titleId?: string;
    withBottomMargin?: boolean;
};

const StyledAppTitle = styled(AppTitle)<{ isMobile?: boolean }>`
    ${({ isMobile }) => css`
        font-weight: 700 !important;
        line-height: 120% !important;

        ${!isMobile
            ? css`
                  font-size: 28px !important;
                  letter-spacing: -0.84px !important;
              `
            : css`
                  font-size: 22px !important;
                  letter-spacing: -0.66px !important;
              `}
    `}
`;

export const AuthFormTitle = ({ titleText, titleId, withBottomMargin }: AuthFormTitleProps) => {
    const { sizes } = useTheme();
    const isMobile = useIsMobile();

    return (
        <StyledAppTitle
            id={titleId}
            textAlign="center"
            margin={0}
            marginBottom={withBottomMargin ? sizes.marginNormal : undefined}
            level={1}
            isMobile={isMobile}
        >
            {titleText}
        </StyledAppTitle>
    );
};
